import React, { ComponentPropsWithoutRef, FC } from 'react';

export interface IGITextProps extends ComponentPropsWithoutRef<'span'> {}

const GIText: FC<IGITextProps> = ({ id, children,  ...rest }) => {
    return (
        <span
            id={id}
            data-testid={id}
            data-automation-id={id}
            className='gi-text'
            {...rest}
        >
            {children}
        </span>
    );
};

export default GIText;